import { render } from "./digitalCommerceServices.vue?vue&type=template&id=429be17b&scoped=true"
import script from "./digitalCommerceServices.vue?vue&type=script&lang=js"
export * from "./digitalCommerceServices.vue?vue&type=script&lang=js"

import "./digitalCommerceServices.vue?vue&type=style&index=0&id=429be17b&scoped=true&lang=css"
import "./digitalCommerceServices.vue?vue&type=style&index=1&id=429be17b&scoped=true&lang=css"
import "./digitalCommerceServices.vue?vue&type=style&index=2&id=429be17b&scoped=true&lang=css"
import "./digitalCommerceServices.vue?vue&type=style&index=3&id=429be17b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429be17b"]])

export default __exports__